var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer admin--footer d-flex flex-column flex-md-row align-items-center justify-content-between"},[_c('p',{staticClass:"text-muted text-center text-md-center"},[_vm._v(" Powered by "),_c('a',{attrs:{"href":"www.hmaserv.com","target":"_blank"}},[_vm._v("HMASERV")])])])
}]

export { render, staticRenderFns }